export default __webpack_public_path__ + "static/media/EBF34A30-00.7883eedf.png";